import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SpinnerService} from './_services/spinner.service';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {delay, Observable} from 'rxjs';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'ehr-root',
  imports: [RouterOutlet, MatProgressSpinner, AsyncPipe],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  spinner$: Observable<boolean>;

  constructor(private spinnerService: SpinnerService,
              private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              private titleService: Title
  ) {
    const appTitle = $localize`:EenvoudigHR Location |website title text:EenvoudigHR Location`;
    this.titleService.setTitle(appTitle);
    this.spinner$ = this.spinnerService.spinner$.pipe(delay(0));

    this.matIconRegistry.addSvgIcon(
      "ehr-mode",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/mode.svg")
    )

    this.matIconRegistry.addSvgIcon(
      "ehr-breadcrumb",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/breadcrumb.svg")
    )

    this.matIconRegistry.addSvgIcon(
      "ehr-close",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/close.svg")
    )

    this.matIconRegistry.addSvgIcon(
      "ehr-check",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/check.svg")
    )

    this.matIconRegistry.addSvgIcon(
      "ehr-filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("/assets/_icons/filter.svg")
    )
  }
}
